export default __webpack_public_path__ + "assets/a2235b05e8bb7e1cd83d4881fe725e69.jpeg";